import { Card, CardContent, TextField, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useRoiPersonalWatchContext } from "../../../context/roi/personal-watch/RoiPersonalWatchContext";
import { useState } from "react";
import { sendData } from "../../../lib/dashboard/actions";
import { mutate } from "swr";
import Loading from "../../../components/loader/Loading";
import { COLORS } from "../../../ui/Theme";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", md: "30%" },
  outline: "none",
  borderRadius: "12px",
};

export default function RoiAddPersonalWatch() {
  const { watches, isAddModal, setIsAddModal, isValidatingWatches } =
    useRoiPersonalWatchContext();

  const [name, setName] = useState("");
  const [isError, setIsError] = useState(false);

  const handleAddWatches = async () => {
    if (!name) setIsError(true);
    else {
      setIsError(false);
      const res = await sendData({ name }, "/favorite/favorite-roi-groups");
      if (res.status === 200) {
        await mutate("/favorite/favorite-roi-groups");
        if (!isValidatingWatches) setIsAddModal(false);
        setName("");
      }
    }
  };

  const handleChangeName = (e) => {
    const value = e.target.value;
    if (!value) {
      setIsError(true);
      setName("");
    } else {
      setIsError(false);
      setName(value);
    }
  };

  return (
    <Modal open={isAddModal} onClose={() => setIsAddModal(false)}>
      <Card sx={style}>
        <CardContent
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            textAlign: "center",
            gap: "15px",
          }}
        >
          {watches.length < 1 && (
            <Typography sx={{ fontSize: "14px", color: COLORS.RED }}>
              (برای بازدید از این صفحه یک دیده‌بان بسازید)
            </Typography>
          )}
          <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
            نام دیده‌بان مورد نظر را وارد نمایید
          </Typography>

          <TextField
            placeholder="دیدبان .."
            onChange={handleChangeName}
            value={name}
            error={!!isError}
            helperText={isError && "لطفا برای دیده‌بان خود یک نام انتخاب کنید"}
          />

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
            }}
          >
            <button
              onClick={handleAddWatches}
              className="btn btn-blue"
              disabled={isValidatingWatches}
            >
              {isValidatingWatches ? (
                <Loading color={"#fff"} />
              ) : (
                "ایجاد دیده‌بان"
              )}
            </button>
            <button
              onClick={() => setIsAddModal(false)}
              className="btn btn-softred"
            >
              انصراف
            </button>
          </Box>
        </CardContent>
      </Card>
    </Modal>
  );
}
